
class SetSizeCommand {
    constructor(params, env) {
        this.params = params;
        this.env = env
    }
    do() {
        if (this.params.id === 'jianshan') {
            let jsContainer = this.env.objects.jsContainer;
            jsContainer.scale.x = this.params.value;
            jsContainer.scale.y = this.params.value;
            jsContainer.scale.z = this.params.value;
            return;
        }
        let containerObject = this.env.getContainerById
            ? this.env.getContainerById(this.params.id)
            : this.env.objects.container;
        if (containerObject && (containerObject.id === this.params.id)) {
            const sourceStartPosition = containerObject.getBindingPosition
                ? containerObject.getBindingPosition()
                : null;
            containerObject.params.size = this.params.value;
            containerObject.updateModel();
            if (sourceStartPosition && this.env.updateFlowersForContainer) {
                this.env.updateFlowersForContainer(containerObject.id, sourceStartPosition);
            }
            if (this.env.render) {
                this.env.render();
            }
            if (this.env.syncLayerState) {
                this.env.syncLayerState();
            }
        } else {
            for (let flowerObject of this.env.objects.flowers) {
                if (this.params.id === flowerObject.id) {
                    flowerObject.clearReal();
                    flowerObject.params.size = this.params.value;
                    flowerObject.updateModel();
                    break;
                }
            }
        }
    }
}

export default SetSizeCommand;
